(()=>{
  const selectors ={
    progressLabel: '#cartSlideoutWrapper .cart-shipping__label',
    progressBar: '#cartSlideoutWrapper .cart-shipping__progress__track',
    freeLable: '#cartSlideoutWrapper .ajax-cart--shipping',
    priceLabel: '#cartSlideoutWrapper .ajax-cart--shipping-message'
  }

  const CURRENCY_RATE = Number(window.Shopify?.currency?.rate) || 1;
  console.log(window.Shopify?.currency)
  const {
    THRESHOLD_EURO,
    CURRENCY,
  } = window.FREE_SHIPPING;
  let threshold;
  switch (CURRENCY.iso_code) {
    case 'EUR':
      threshold = THRESHOLD_EURO;
      break;
    default:
      threshold = THRESHOLD_EURO * CURRENCY_RATE;
      break;
  }
  /**
   * Handles the update of the cart drawer.
   * @param {Event} e - The event object.
   */
  const handleCartUpdate = (e) => {
    const cart = e.detail;
    const total = cart.total_price;
    const difference = threshold - total;
    const prLabel = document.querySelector(selectors.progressLabel);

    const tempDiv = document.createElement('div');

    const successMessage = prLabel.dataset.success;
    const pendingMessage = prLabel.dataset.pending;

    if(difference <= 0){
      prLabel.querySelector(".cart-drawer--title").innerHTML = successMessage;
      document.querySelector(selectors.progressBar).style.width = `100%`
      document.querySelector(selectors.priceLabel).classList.add("hide");
      document.querySelector(selectors.freeLable).classList.remove("hide")
    }else{
      const currentShipping = `${(difference / 100).toFixed(2)}${CURRENCY.symbol}`;
      tempDiv.innerHTML = pendingMessage;
      tempDiv.querySelector(".money").textContent = currentShipping
      prLabel.querySelector(".cart-drawer--title").innerHTML = tempDiv.innerHTML;

      const percentage = ((total / threshold) * 100).toFixed(2);
      document.querySelector(selectors.progressBar).style.width = `${percentage}%`

      document.querySelector(selectors.priceLabel).classList.remove("hide");
      document.querySelector(selectors.freeLable).classList.add("hide")
    }
   
  }

  document.addEventListener('update-cart-drawer', handleCartUpdate);
})()